(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gv-secao-model-1"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gv-bp-carousel')) {
  customElements.define('gv-bp-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.track = this.querySelector('[data-track]');
      this.cards = Array.from(this.track.children);
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));

      this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.current() - 1));
      this.querySelector('[data-next]').addEventListener('click', () => this.go(this.current() + 1));
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index)));
      this.track.addEventListener('scroll', () => requestAnimationFrame(() => this.sync()), { passive: true });
    }

    offset(card) {
      return card.offsetLeft - this.cards[0].offsetLeft;
    }

    current() {
      return this.cards.reduce((closest, card, index) => (
        Math.abs(this.offset(card) - this.track.scrollLeft) < Math.abs(this.offset(this.cards[closest]) - this.track.scrollLeft) ? index : closest
      ), 0);
    }

    go(index) {
      const safe = Math.max(0, Math.min(index, this.cards.length - 1));
      this.track.scrollTo({ left: this.offset(this.cards[safe]), behavior: 'smooth' });
      this.sync(safe);
    }

    sync(index = this.current()) {
      this.dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gv-secao-model-2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gv-va-tabs')) {
  customElements.define('gv-va-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));

      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.show(tab.dataset.tab)));
      this.querySelector('[data-prev]').addEventListener('click', () => this.scroll(-1));
      this.querySelector('[data-next]').addEventListener('click', () => this.scroll(1));

      // No editor de temas, ao selecionar um bloco, abre a aba dele
      this.addEventListener('shopify:block:select', (event) => {
        const tab = event.target.closest('[data-tab]');
        if (tab) this.show(tab.dataset.tab);
      });
    }

    show(index) {
      this.querySelectorAll('[data-pane]').forEach((el) => { el.hidden = el.dataset.pane !== String(index); });
      this.tabs.forEach((tab) => {
        const active = tab.dataset.tab === String(index);
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });
      const grid = this.activeGrid();
      if (grid) grid.scrollTo({ left: 0, behavior: 'auto' });
    }

    activeGrid() {
      return this.querySelector('[data-grid]:not([hidden])');
    }

    scroll(direction) {
      const grid = this.activeGrid();
      if (!grid) return;
      const card = grid.firstElementChild;
      const distance = card ? card.getBoundingClientRect().width + 13 : grid.clientWidth;
      grid.scrollBy({ left: distance * direction, behavior: 'smooth' });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gv-secao-model-3"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gv-nc-carousel')) {
  customElements.define('gv-nc-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.track = this.querySelector('[data-track]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');

      this.prev.addEventListener('click', () => this.track.scrollBy({ left: -this.track.clientWidth, behavior: 'smooth' }));
      this.next.addEventListener('click', () => this.track.scrollBy({ left: this.track.clientWidth, behavior: 'smooth' }));
      this.track.addEventListener('scroll', () => requestAnimationFrame(() => this.update()), { passive: true });
      this._onResize = () => this.update();
      window.addEventListener('resize', this._onResize);
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onResize);
    }

    update() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-video-slider"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('gv-video-slider')) return;
  let swiperLoad;

  function loadSwiper(src) {
    if (window.Swiper) return Promise.resolve(window.Swiper);
    if (swiperLoad) return swiperLoad;
    swiperLoad = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      const timer = setTimeout(() => finish(new Error('Swiper loading timeout')), 15000);
      function finish(error) {
        clearTimeout(timer);
        script.onload = null;
        script.onerror = null;
        if (error || !window.Swiper) {
          script.remove();
          reject(error || new Error('Swiper unavailable'));
        } else resolve(window.Swiper);
      }
      script.onload = () => finish();
      script.onerror = () => finish(new Error('Swiper loading failed'));
      document.head.appendChild(script);
    }).catch((error) => {
      swiperLoad = null;
      throw error;
    });
    return swiperLoad;
  }

  class GVVideoSlider extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.track = this.querySelector('[data-gv-video-track]');
      this.slides = Array.from(this.querySelectorAll('[data-gv-video-slide]'));
      if (!this.track || !this.slides.length) return;
      this.visible = false;
      this.playingSlide = null;
      this.selectedSlide = this.slides[0];
      this.userPaused = new WeakSet();
      const signal = this.controller.signal;
      this.addEventListener('click', (event) => this.onClick(event), { signal });
      this.addEventListener('focusin', () => this.prepare(), { signal });
      this.addEventListener('pointerover', () => this.prepare(), { passive: true, signal });
      document.addEventListener('visibilitychange', () => this.syncPlayback(), { signal });
      this.querySelectorAll('video').forEach((video) => {
        video.addEventListener('play', () => this.setPlaying(video.closest('[data-gv-video-slide]'), true), { signal });
        video.addEventListener('pause', () => this.setPlaying(video.closest('[data-gv-video-slide]'), false), { signal });
      });
      this.querySelectorAll('iframe').forEach((frame) => {
        frame.addEventListener('load', () => {
          const slide = frame.closest('[data-gv-video-slide]');
          if (!this.visible || document.hidden || slide !== this.playingSlide) this.pauseSlide(slide);
        }, { signal });
      });
      if ('IntersectionObserver' in window) {
        this.nearObserver = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.nearObserver.disconnect();
            this.prepare();
          }
        }, { rootMargin: '600px' });
        this.nearObserver.observe(this);
        this.visibilityObserver = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.1;
          if (this.visible) this.prepare();
          this.syncPlayback();
        }, { threshold: [0, 0.1] });
        this.visibilityObserver.observe(this);
      } else {
        this.prepare();
      }
    }

    async prepare() {
      if (this.slider || this.preparing || !this.controller) return;
      this.querySelectorAll('video[data-poster]').forEach((video) => {
        video.poster = video.dataset.poster;
        video.removeAttribute('data-poster');
      });
      const controller = this.controller;
      this.preparing = true;
      try {
        const Swiper = await loadSwiper(this.dataset.swiperSrc);
        if (!this.isConnected || this.controller !== controller) return;
        const settings = this.track.dataset;
        const effect = (gap) => ({
          rotate: Number(settings.sliderRotate), stretch: 0,
          depth: Number(gap) === 0 ? 200 : 0,
          scale: Number(gap) === 0 ? 1 : 0.9, modifier: 1, slideShadows: false
        });
        this.slider = new Swiper(this.track, {
          init: false,
          effect: 'coverflow',
          navigation: {
            nextEl: this.querySelector('[data-gv-video-next]'),
            prevEl: this.querySelector('[data-gv-video-prev]')
          },
          a11y: {
            nextSlideMessage: this.dataset.nextLabel,
            prevSlideMessage: this.dataset.previousLabel
          },
          loopAdditionalSlides: 0,
          loop: this.slides.length > 1,
          initialSlide: 0,
          breakpoints: {
            0: {
              slidesPerView: Number(settings.sliderViewMobile), centeredSlides: true,
              spaceBetween: Number(settings.sliderGapMobile), coverflowEffect: effect(settings.sliderGapMobile)
            },
            768: {
              slidesPerView: Number(settings.sliderViewTablet),
              centeredSlides: [3, 5].includes(Number(settings.sliderViewTablet)),
              spaceBetween: Number(settings.sliderGapMobile), coverflowEffect: effect(settings.sliderGapMobile)
            },
            1024: {
              slidesPerView: Number(settings.sliderView),
              centeredSlides: [3, 5].includes(Number(settings.sliderView)),
              spaceBetween: Number(settings.sliderGap), coverflowEffect: effect(settings.sliderGap)
            }
          },
          on: {
            slideChange: (swiper) => {
              this.selectedSlide = swiper.slides[swiper.activeIndex];
              this.syncPlayback();
            }
          }
        });
        this.track.classList.remove('preview');
        this.slider.init();
        this.selectedSlide = this.slider.slides[this.slider.activeIndex] || this.slides[0];
        this.syncPlayback();
      } catch {
        this.track.classList.add('preview');
      } finally {
        if (this.controller === controller) this.preparing = false;
      }
    }

    canAutoplay() {
      return !window.matchMedia('(prefers-reduced-motion: reduce)').matches && !navigator.connection?.saveData;
    }

    syncPlayback() {
      if (!this.visible || document.hidden || !this.canAutoplay() || this.userPaused.has(this.selectedSlide)) {
        this.pauseAll();
        return;
      }
      this.playSlide(this.selectedSlide);
    }

    setPlaying(slide, playing) {
      const button = slide?.querySelector('[data-gv-video-action]');
      button?.classList.toggle('active', playing);
      button?.setAttribute('aria-pressed', String(playing));
    }

    frameCommand(frame, playing) {
      if (!frame.hasAttribute('src')) return;
      const isYoutube = frame.dataset.provider === 'youtube';
      const command = isYoutube
        ? { event: 'command', func: playing ? 'playVideo' : 'pauseVideo', args: [] }
        : { method: playing ? 'play' : 'pause' };
      frame.contentWindow?.postMessage(JSON.stringify(command), isYoutube ? 'https://www.youtube.com' : 'https://player.vimeo.com');
    }

    pauseSlide(slide) {
      const video = slide.querySelector('video');
      if (video && !video.paused) video.pause();
      const frame = slide.querySelector('iframe');
      if (frame) this.frameCommand(frame, false);
      this.setPlaying(slide, false);
      if (this.playingSlide === slide) this.playingSlide = null;
    }

    pauseAll(except) {
      this.slides.forEach((slide) => {
        if (slide !== except) this.pauseSlide(slide);
      });
    }

    playSlide(slide, manual = false) {
      if (!slide || !this.isConnected || document.hidden || (!manual && !this.visible)) return;
      this.pauseAll(slide);
      const video = slide.querySelector('video');
      const frame = slide.querySelector('iframe');
      this.playingSlide = slide;
      if (video) {
        if (!video.hasAttribute('src') && video.dataset.src) {
          video.src = video.dataset.src;
          video.load();
        }
        if (!video.paused) return;
        const controller = this.controller;
        video.play()?.then(() => {
          if (this.controller !== controller || !this.isConnected || document.hidden || this.playingSlide !== slide || (!manual && !this.visible)) {
            video.pause();
          }
        }).catch(() => {
          this.setPlaying(slide, false);
          if (this.playingSlide === slide) this.playingSlide = null;
        });
      } else if (frame) {
        if (!frame.hasAttribute('src')) frame.src = frame.dataset.src;
        else this.frameCommand(frame, true);
        this.setPlaying(slide, true);
      }
    }

    onClick(event) {
      const button = event.target.closest('[data-gv-video-action], [data-gv-video-sound]');
      if (!button || button.closest('gv-video-slider') !== this) return;
      this.prepare();
      const slide = button.closest('[data-gv-video-slide]');
      if (button.hasAttribute('data-gv-video-sound')) {
        const video = slide.querySelector('video');
        if (!video) return;
        video.muted = !video.muted;
        button.classList.toggle('active', !video.muted);
        button.setAttribute('aria-pressed', String(!video.muted));
        button.setAttribute('aria-label', video.muted ? this.dataset.unmuteLabel : this.dataset.muteLabel);
      } else {
        this.selectedSlide = slide;
        const video = slide.querySelector('video');
        const playing = video ? !video.paused : this.playingSlide === slide;
        if (playing) {
          this.userPaused.add(slide);
          this.pauseSlide(slide);
        } else {
          this.userPaused.delete(slide);
          this.playSlide(slide, true);
        }
      }
    }

    disconnectedCallback() {
      this.nearObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.pauseAll();
      this.controller?.abort();
      this.controller = null;
      this.preparing = false;
      this.slider?.destroy(true, true);
      this.slider = null;
      this.track?.classList.add('preview');
    }
  }

  customElements.define('gv-video-slider', GVVideoSlider);
})();


  } catch(e) { console.error(e); }
})();
})();
